import { useEffect, useState } from "react";
import {
  getMIDList,
  getTerminalsByMID,
} from "../services/services";

export const useMerchantTerminal = (setValues) => {
  const [merchants, setMerchants] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [isLoadedMerchants, setIsLoadedMerchants] = useState(false);
  const [isLoadedTerminals, setLoadedMerchants] = useState(true);

  const onChangeMerchant = (_, newInputValue) => {
    if (!newInputValue) {
      setTerminals([]);
      setValues((prev) => ({
        ...prev,
        terminal_id: "",
        merchant_id: "",
      }));
      return;
    }

    if (terminals.length > 0) {
      setTerminals([]);
    }
    setValues((prev) => ({
      ...prev,
      merchant_id: newInputValue,
      terminal_id: "",
    }));
    
    isLoadedTerminals && setLoadedMerchants(false);
    getTerminalsByMID(newInputValue?.id, (data) => {
      setTerminals(data ?? []);
    },
    setLoadedMerchants)
  };

  useEffect(() => {
    getMIDList((data) => {
      setMerchants(data ?? []);
    },
    setIsLoadedMerchants);
  }, []);

  return {
    merchants,
    terminals,
    isLoadedMerchants,
    isLoadedTerminals,
    onChangeMerchant,
  };
};
